module.exports = __webpack_public_path__ + "a41d11295145fc0a522ffd15136280ec.png";